import { AssistentCustomFormItem, AssistentItem } from '../assistent_config';
import { IDs } from '../../../../helpers/IDs';
// import { KraftstoffeButtonWrapper } from './wrapper/KraftstoffeButtonWrapper';
import * as React from 'react';
import { TriggerService } from '../../../../core/trigger/trigger_service';


export function getAssistentConfigKraftstoffe(standort: any, data: any, jahr: number, triggerService: TriggerService, customCfg?: AssistentItem): AssistentItem {
    const eingangs_kraftstoffe = {
        gliederung: '2.3',
        name: 'Kraftstoffe',
        dataName: 'Kraftstoffe',
        description: 'Dies ist das Formular zur Eingabe der Kraftstoff-Daten.',
        type: 'EntityForm',
        entity: IDs.ENT_ENERGIEDATEN_KRAFTSTOFFE,
        style: {marginLeft: '18px'},
        configFlag: 'inputKraftstoffe',
        customOnChange: customOnChange,
        customOnSaveDone: (entity: string, dataItem: any) => {
            triggerService.fire('reload', IDs.ENT_ENERGIEDATEN_WAERME);
        },
        addLabel: 'Neuen Kraftstoff-Datensatz erfassen',
        ... (customCfg || {})
        // customTopElement: (entity: string, item: any, callback?: (data: any) => void) =>
        // <KraftstoffeButtonWrapper
        //     jahr={jahr}
        //     standortSelected={standort}
        //     values={item}
        //     data={data}
        //     callback={callback}
        // />
    };
    return eingangs_kraftstoffe;
}

function customOnChange(dataItem: any, data: any, contextService: any) {
    if (dataItem.popup_shown) {
        return;
    }
    if (!dataItem.tid || dataItem.tid === 0) {
        if (dataItem.energietraeger_tid_orig === 7 || dataItem.energietraeger_tid === 7) { /* {7} Ladestrom [kWh] */
            dataItem.popup_shown = true;
            showKraftstoffeEnergietraegerLadestromMessage();
        }
    } else {
        const arr = data[IDs.ENT_ENERGIEDATEN_KRAFTSTOFFE] || [];
        const found = arr.find((item: any) => item.tid === dataItem.tid);
        if (found) {
            if (
                (dataItem.energietraeger_tid_orig === 7 || dataItem.energietraeger_tid === 7)
                && (!found.energietraeger_tid_orig || found.energietraeger_tid_orig !== 7 || !dataItem.energietraeger_tid_orig)
            ) { /* {7} Ladestrom [kWh] */
                showKraftstoffeEnergietraegerLadestromMessage();
                dataItem.popup_shown = true;
                dataItem.energietraeger_tid_orig = 7;
            } else if (dataItem.energietraeger_tid === 7 && !found.energietraeger_tid) {
                showKraftstoffeEnergietraegerLadestromMessage();
                dataItem.popup_shown = true;
                dataItem.energietraeger_tid_orig = 7;
            }
        }
        if (dataItem.energietraeger_tid_name !== 'Ladestrom [kWh]' || dataItem.energietraeger_tid !== 7) {
            // dataItem.energietraeger_tid_orig = '';
            delete dataItem.energietraeger_tid_orig;
        }
    }
}

function showKraftstoffeEnergietraegerLadestromMessage() {
    const msg = 'Bitte geben Sie hier nur dann Verbrauchsdaten ein, wenn der Strom für Ihr/e E-Fahrzeug/e separat vom restlichen Strom abgerechnet wird und somit nicht bereits zuvor unter "Strom" erfasst wurde.';
    alert(msg);
}
